import React, { useRef } from 'react';
import { Input } from 'antd';
import EmojiPickerButton from './EmojiPickerButton';
import { useEmojiInsert } from '../hooks/useEmojiInsert';

const { TextArea } = Input;

interface EmojiTextAreaProps {
  id?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  rows?: number;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
}

/**
 * Ported from Authentication76's EmojiTextArea — a drop-in replacement for
 * antd's Input.TextArea with an emoji picker button in the corner. Same
 * value/onChange(value) shape (plus id/onBlur), so it works inside a
 * Form.Item exactly like TextArea does.
 */
const EmojiTextArea: React.FC<EmojiTextAreaProps> = ({
  id,
  value,
  onChange,
  onBlur,
  rows = 4,
  placeholder,
  disabled,
  maxLength,
}) => {
  const textAreaRef = useRef<any>(null);
  const insertEmoji = useEmojiInsert(textAreaRef, value, (next) => onChange?.(next));

  return (
    <div style={{ position: 'relative' }}>
      <TextArea
        id={id}
        ref={textAreaRef}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        style={{ paddingRight: 36 }}
      />
      <div style={{ position: 'absolute', bottom: 4, right: 4 }}>
        <EmojiPickerButton onSelect={insertEmoji} disabled={disabled} />
      </div>
    </div>
  );
};

export default EmojiTextArea;
